import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';


class LabelStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getAll() {
        return this.getState().sort((a, b) => a.id - b.id);
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.LABEL_LIST_SUCCESS:
                return action.data;

            case ActionTypes.LABEL_SAVE_SUCCESS:
                return [
                    ...state,
                    action.data
                ];

            case ActionTypes.LABEL_UPDATE_SUCCESS:
                return [
                    ...state.filter(({id}) => Number(id) !== Number(action.payload.id)),
                    action.data
                ];

            case ActionTypes.LABEL_DELETE_SUCCESS:
                return state.filter(({id}) => Number(id) !== Number(action.payload.id));

            default:
                return state;

        }
    }
}

export default new LabelStore(Dispatcher);
